import React, { useEffect, useRef } from 'react';
import { Menu } from 'primereact/menu';
import classNames from 'classnames';
import { Button as PrimeButton, ButtonProps } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons';
import { MenuItem } from 'primereact/menuitem';
import { usePermissionContext } from 'contexts/PermissionContext';
import './Orderlines.scss';

type ToggleMenuProps = {
  menuItems: MenuItem[];
  isButtonDisable: boolean;
  outlined?: boolean;
};
export default function ToggleMenu({ menuItems, isButtonDisable, outlined }: ToggleMenuProps) {
  const actionRef = useRef<Menu>(null);
  const menuRootWrapperRef = useRef<HTMLDivElement>(null);
  const { userIsDeactivatedWithActiveOrderlines } = usePermissionContext();
  const toggleCreativeActionSelect: ButtonProps['onClick'] = event => {
    if (actionRef && actionRef.current) {
      actionRef.current.toggle(event);
    }
  };
  useEffect(() => {
    // this useEffect closes the opened dropdown which is not changing it's place then scrolling the window
    const handleScroll = () => {
      if (actionRef.current) {
        const fakeEvent = new Event('scroll');
        actionRef.current.hide(fakeEvent as unknown as React.SyntheticEvent);
      }
    };
    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);
  const handleClickOutside = (event: React.FocusEvent<HTMLDivElement>) => {
    if (actionRef.current?.hide) {
      const fakeEvent = new Event('click');
      actionRef.current.hide(fakeEvent as unknown as React.SyntheticEvent);
    }
  };

  return (
    <div ref={menuRootWrapperRef} className="orderline-actions-wrapper">
      <Menu
        className="orderline-actions-menu"
        ref={actionRef}
        popup
        id="popup_menu_right"
        popupAlignment="right"
        model={menuItems}
        onBlur={handleClickOutside}
      />
      <PrimeButton
        className={classNames('orderline-action-btn', outlined && 'generated-banner-toggle')}
        disabled={userIsDeactivatedWithActiveOrderlines || isButtonDisable}
        onClick={toggleCreativeActionSelect}
        icon={
          <FontAwesomeIcon
            icon={faEllipsisV}
            color={isButtonDisable ? '#EAECF0' : '#757575'}
            style={{ fontSize: 20 }}
          />
        }
        aria-controls="popup_menu_right"
        aria-haspopup
      />
    </div>
  );
}
